import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { AmountTD, CurrencyTD, SmallOnly, Td, LargeOnly } from "commons";
import { format } from "commons/src/NuDateUtils";

import { TrxTr } from "./styled/TrxTr";
import { FeesTD } from "./FeesTD";

export class InvestmentTransaction extends PureComponent {
    static makeNarrative(investmentTransaction) {
        if (investmentTransaction.fake) {
            return investmentTransaction.itrnTtypDescription;
        }

        let displayStatus = "";
        if (InvestmentTransaction.isTradeUnsettled(investmentTransaction)) {
            displayStatus =
                investmentTransaction.xordExpCashSettlementDate === null
                    ? `(${investmentTransaction.orderStatus})`
                    : `(${investmentTransaction.orderStatus} - exp. ${format(
                          investmentTransaction.xordExpCashSettlementDate
                      )})`;
        }
        return `${investmentTransaction.itrnTtypDescription} - ${investmentTransaction.fund.longName} ${displayStatus}`;
    }

    static isTradeUnsettled(investmentTransaction) {
        return ["Not ordered", "Settled", "Cancelled"].every(
            status => status !== investmentTransaction.orderStatus
        );
    }

    renderIHInvestmentTransaction = () => {
        const isTradeUnsettled = InvestmentTransaction.isTradeUnsettled(
            this.props.investmentTransaction
        );
        return (
            <ExpandedTr
                italic={isTradeUnsettled}
                className="investment-transaction"
                isClientPortal={this.props.isClientPortal}
            >
                <Td leftPad="20px">{format(this.props.investmentTransaction.itrnEffectiveDate)}</Td>
                {this.props.isClientPortal && (
                    <SmallOnly>
                        <Td />
                    </SmallOnly>
                )}
                {this.props.isClientPortal && (
                    <SmallOnly>
                        <Td />
                    </SmallOnly>
                )}
                <Td leftPad="20px">Net payment (minus tax) {this.props.narrative.toLowerCase()}</Td>
                {this.props.isClientPortal && (
                    <SmallOnly>
                        <CurrencyTD amount={this.props.investmentTransaction.itrnEffectiveAmount} />
                    </SmallOnly>
                )}
                <LargeOnly enabled={this.props.isClientPortal}>
                    <CurrencyTD amount={this.props.investmentTransaction.itrnEffectiveAmount} />
                </LargeOnly>
            </ExpandedTr>
        );
    };

    renderInvestmentTransaction = () => {
        const isTradeUnsettled = InvestmentTransaction.isTradeUnsettled(
            this.props.investmentTransaction
        );
        const shouldDisplayPriceUnitsAmount =
            this.props.investmentTransaction.orderStatus !== "Awaiting confirmation" &&
            this.props.investmentTransaction.orderStatus !== "Awaiting order" &&
            this.props.investmentTransaction.fake === undefined;
        const unitsAmount = shouldDisplayPriceUnitsAmount
            ? this.props.investmentTransaction.itrnEffectiveUnits
            : null;

        return (
            <ExpandedTr
                italic={isTradeUnsettled}
                className="investment-transaction"
                isClientPortal={this.props.isClientPortal}
            >
                <Td leftPad="20px">{format(this.props.investmentTransaction.itrnEffectiveDate)}</Td>
                {this.props.isClientPortal && (
                    <SmallOnly>
                        <Td data-testid="small-cp-empty-cell" />
                    </SmallOnly>
                )}
                <Td leftPad="20px">{}</Td>
                <LargeOnly enabled={this.props.isClientPortal}>
                    <Td leftPad="20px" />
                </LargeOnly>
                <Td leftPad="20px">{this.props.narrative}</Td>
                {this.props.isClientPortal && (
                    <SmallOnly>
                        <CurrencyTD
                            data-testid="small-cp-effective-amount"
                            amount={this.props.investmentTransaction.itrnEffectiveAmount}
                        />
                    </SmallOnly>
                )}
                <AmountTD amount={unitsAmount}>{unitsAmount}</AmountTD>
                <CurrencyTD
                    amount={
                        shouldDisplayPriceUnitsAmount
                            ? this.props.investmentTransaction.itrnPriceApplied
                            : null
                    }
                    nbDecimals={4}
                />
                <FeesTD
                    fees={this.props.investmentTransaction.itrnFees}
                    amountInFeesColumn={this.props.investmentTransaction.fake}
                />
                <LargeOnly enabled={this.props.isClientPortal}>
                    <CurrencyTD amount={this.props.investmentTransaction.itrnEffectiveAmount} />
                </LargeOnly>
                <Td />
            </ExpandedTr>
        );
    };

    render() {
        return this.props.isIncomeHistory
            ? this.renderIHInvestmentTransaction()
            : this.renderInvestmentTransaction();
    }
}

export const ExpandedTr = styled(TrxTr)`
    background: #fff6ed !important;

    @media only screen and (max-width: ${props => props.theme.maxWidth}) {
        margin: auto;
        margin-bottom: 8px;
        width: 94%;
        border: 4px solid #fff6ed !important;
    }
`;

InvestmentTransaction.propTypes = {
    investmentTransaction: PropTypes.shape({
        itrnTtypCode: PropTypes.string,
        itrnMappings: PropTypes.object,
        itrnTtypDescription: PropTypes.string,
        fake: PropTypes.bool,
        fund: PropTypes.shape({
            longName: PropTypes.string
        }),
        itrnEffectiveUnits: PropTypes.number,
        itrnPriceApplied: PropTypes.number,
        itrnEffectiveAmount: PropTypes.number,
        itrnEffectiveDate: PropTypes.string,
        itrnFees: PropTypes.array,
        orderStatus: PropTypes.string,
        xordExpCashSettlementDate: PropTypes.string
    }),
    narrative: PropTypes.string,
    isClientPortal: PropTypes.bool,
    isIncomeHistory: PropTypes.bool
};

InvestmentTransaction.defaultProps = {
    isIncomeHistory: false
};
